import styled from "styled-components";
import formatNumberToString from "../../../utils/formatNumber";
import { useAdmin } from "../../../context/admin";
import { MdSwapHoriz } from "react-icons/md";

interface Balance {
    positive: number,
    negative: number
}

export default function Header({positive, negative}: Balance) {
    const { setIsCreateReTraspasoModalOpen } = useAdmin()
    return (
        <Main>
            <div className="top-row">
                <div className="general-balance">
                    Balance General
                </div>
                <button
                    type="button"
                    className="re-traspaso-btn"
                    onClick={() => setIsCreateReTraspasoModalOpen(true)}
                    title="Register Re-traspaso"
                >
                    <MdSwapHoriz />
                    Re-traspaso
                </button>
            </div>
            <div className="account">
                <span className="positive">$ {formatNumberToString(positive)}</span>
                <span className="negative">$ {formatNumberToString(negative)}</span>
            </div>
            <div className="account">
                <span className="general">
                $ {formatNumberToString(positive + negative)}
                </span>
            </div>
        </Main>
    )
}

const Main = styled.div`
.top-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
}
.re-traspaso-btn {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px 12px;
    font-size: 13px;
    background-color: ${props => props.theme.white};
    color: ${props => props.theme.blueLight};
    border: 1px solid ${props => props.theme.blueLight};
    border-radius: 6px;
    cursor: pointer;
    transition: background-color .2s, color .2s;
    svg { font-size: 16px; }
    &:hover {
        background-color: ${props => props.theme.blueLight};
        color: ${props => props.theme.white};
    }
}
.general-balance {
    padding: 5px 10px;
    font-size: 18px;
    background-color: ${props => props.theme.blueLight};
    text-align: center;
    width: fit-content;
    margin: auto;
    color: ${props => props.theme.white};
}
.account {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80%;
    max-width: 350px;
    margin: 20px auto;
    > span {
        padding: 5px 10px;
        flex: 1;
        text-align: center;
        display: block;
        color: ${props => props.theme.white};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &.general {
            width: fit-content;
            background-color: ${props => props.theme.blueLight};
        }
        &.positive {
            background-color: ${props => props.theme.lightGreen};
        }
        &.negative {
            background-color: ${props => props.theme.red};
        }
    }
}
`